import { render, staticRenderFns } from "./CustomFiltersList.vue?vue&type=template&id=5b60755b&scoped=true&"
import script from "./CustomFiltersList.vue?vue&type=script&lang=js&"
export * from "./CustomFiltersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFiltersList.vue?vue&type=style&index=0&id=5b60755b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60755b",
  null
  
)

export default component.exports